import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';

/**
 * Ячейка с типом данных 'Да/Нет'
 */
@Component({
    selector: 'app-bool-cell',
    template: ' {{ getRawValue() | formater: column.type }}',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoolCellComponent extends BaseCellComponent {}
